import { isFocusGroupStudy } from 'containers/FocusGroups/utils/focus-group-study';
import { BOOKING_TYPE, NOTIFICATION_TYPE } from 'lib/constants';

type NotificationBooking = Parameters<typeof isFocusGroupStudy>[0]['study'] & { type?: number | null };

/**
 * Where a notification goes.
 *
 * Message notifications are stored linked at `/bookings/:id/messages`. That route redirects study
 * shapes that use a newer experience to the study, not to the message, so this resolves the
 * equivalent screen. The focus-group branch tests the same three conditions BookingContainer
 * redirects on, so it diverts only links that route would redirect.
 *
 * @todo: fix these links in the backend.
 */
export const notificationLink = ({
  link,
  type,
  booking,
  isLabsEnabled,
  prefersClassic,
}: {
  link: string;
  type: number | null | undefined;
  booking: NotificationBooking | null | undefined;
  isLabsEnabled: boolean;
  prefersClassic: boolean;
}): string => {
  if (type !== NOTIFICATION_TYPE.MESSAGES) {
    return link;
  }

  const messagesIn = (path: string) => link.replace(/^\/bookings\/([^/]+)\/messages/, path);

  if (booking?.type === BOOKING_TYPE.UNMODERATED || booking?.type === BOOKING_TYPE.AI_MODERATED) {
    return messagesIn('/studies/$1/recruit/messages');
  }

  if (isLabsEnabled && !prefersClassic && isFocusGroupStudy({ study: booking })) {
    return messagesIn('/labs/focus-groups/$1/messages');
  }

  return link;
};
